export default "__VITE_ASSET__uZ8Fss7J__"